<!-- WEXHUB: override de componente upstream -->
<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm">
    <button
      class="flex items-center select-none w-full rounded-lg bg-n-slate-2 outline outline-1 outline-n-weak m-0 cursor-pointer justify-between py-2 px-2"
      :class="{ 'rounded-bl-none rounded-br-none': isOpen }"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-2">
        <Icon
          icon="i-woot-drag-indicator"
          class="drag-handle size-3 text-n-slate-7 cursor-grab shrink-0"
          @click.stop
        />
        <EmojiOrIcon
          class="inline-block w-5 shrink-0"
          :icon="icon"
          :emoji="emoji"
        />
        <h5 class="text-n-slate-12 text-sm mb-0 py-0">
          {{ title }}
        </h5>
      </div>
      <div class="flex items-center gap-2">
        <slot name="button" />
        <fluent-icon
          size="16"
          icon="chevron-down"
          type="outline"
          class="text-n-blue-11 transition-transform duration-200 shrink-0"
          :class="{ 'rotate-180': isOpen }"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="outline outline-1 outline-n-weak -mt-[-1px] border-t-0 rounded-br-lg rounded-bl-lg"
      :class="compact ? 'p-0' : 'px-2 py-4'"
    >
      <slot />
    </div>
  </div>
</template>
